import cn from 'classnames';
import { memo } from 'react';
import { ArrowShortRight } from '@shared/assets/index.ts';
import { SCard10 } from '@shared/styles/styledComponentsCommon';
import { FormFieldWithLabel, type FormFieldWithLabelPT } from '@shared/ui/forms/FieldWithLabel/ui';
import { IconButton } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

export type FieldWithLabelAndCardPT = Omit<FormFieldWithLabelPT, 'label'> & {
  fieldLabel?: string;
  helperText?: string;
  withRedirectArrow?: boolean;
};

export const FormFieldWithLabelAndCard = memo(
  ({
    children,
    fieldLabel,
    className,
    helperText,
    withRedirectArrow,
    ...props
  }: FieldWithLabelAndCardPT) => {
    return (
      <FormFieldWithLabel label={fieldLabel} {...props}>
        <SCard10 className={cn(withRedirectArrow && st.withRedirectArrow, className)}>
          {children}
          {helperText && <p className={st.helperText}>{helperText}</p>}
          {withRedirectArrow && (
            <IconButton variant="white" className={st.redirectArrow}>
              <ArrowShortRight />
            </IconButton>
          )}
        </SCard10>
      </FormFieldWithLabel>
    );
  }
);
